import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import catalogueFormState from '../forms/state/catalogueForm';
import catalogueTemplateState from './catalogueTemplate';
import collectionState from './collection';
import collectionsState from './collections';
import dataState from './data';
import datasetAttachmentsState from '../attachments/state/datasetAttachments';
import datasetCatalogueState from './catalogue';
import datasetDataModel from './datamodel';
import datasetDictionariesDataState from '../dictionaries/state/data';
import datasetDictionariesState from '../dictionaries/state/datasetDictionaries';
import datasetLinksState from '../links/state/datasetLinks';
import datasetState from './dataset';
import datasetStatusState from '../status/state/datasetStatus';
import datasetSubscriptionsState from '../subscriptions/state/datasetSubscriptions';
import datasetsState from './datasets';
import requestSubscriptionsState from '../subscriptions/state/requestSubscriptions';
import wizardState from './wizard';

export const handlers = {
  ...catalogueFormState,
  ...catalogueTemplateState,
  ...collectionState,
  ...collectionsState,
  ...dataState,
  ...datasetAttachmentsState,
  ...datasetCatalogueState,
  ...datasetDataModel,
  ...datasetDictionariesDataState,
  ...datasetDictionariesState,
  ...datasetLinksState,
  ...datasetState,
  ...datasetStatusState,
  ...datasetSubscriptionsState,
  ...datasetsState,
  ...requestSubscriptionsState,
  ...wizardState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
